import React from 'react'
import { NavLink } from "react-router-dom";
import menu from './Menu.json'

const MenuItem = (props) => {
    return (
        <li className="nav-item">
            <NavLink className="nav-link link-collapser" to={props.item.link}>{props.item.item}</NavLink>
        </li>
    )
}

const MenuItems = (props) => {
    return props.items.map((e, i) => (
        <MenuItem key={i} item={e} />
    ));
}

const Menu = (props) => {
    return (
        <div className="collapse navbar-collapse" id="navbarResponsive">
            <ul className="navbar-nav text-uppercase ml-auto">
                <MenuItems items={menu} />
                <li className="nav-item">
                    <a href="https://www.facebook.com/paolo.stoppa.963" target="_blank" className="nav-link" rel="noopener noreferrer">
                        <i className="fab fa-facebook-square" style={{ fontSize: '22px' }}></i>
                    </a>
                </li>
                <li className="nav-item">
                    <NavLink to="/guestbook" className="nav-link"><i className="fas fa-bookmark"></i></NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/search" className="nav-link"><i className="fas fa-search"></i></NavLink>
                </li>
            </ul>
        </div>
    );
}

export default Menu;